<template>
  <v-card
    tile
    elevation="0"
    class="d-flex flex-column justify-center py-12"
    :min-height="settings.bg && settings.bg.height ? settings.bg.height : '350px'"
    :color="MIXIN_getBgInfo(settings, 'color')"
    :img="MIXIN_getBgInfo(settings, 'image')"
  >
    <section class="d-flex flex-column">
      <title-component :id="id" :settings="{...settingsTitle, idLayout: settings.idLayout}" />
      
      <div class="div-style-width">
        <div
          v-if="productErrorMessage && settings.layout !== 'custom'"
          :style="
            `
            height: ${settings.height ? settings.height - 200 : '378px'}; 
            display: flex; justify-content: center; align-items: center
            `
          "
          justify="center"
          no-gutters
        >
          <b :style="`font-size: 20px; color: ${settings.title.color}`">
            {{productErrorMessage}}
          </b>
        </div>

        <v-row justify="center" no-gutters style="max-width: 1340px !important">
          <component 
            :is="getComponent"
            :settings="settings"
            :getTicketsForLayoutV2="getTicketsForLayoutV2"
            :splitArray="splitArray"
            :openCheckout="openCheckout"
            @onBuyTicket="onBuyTicket"
          />
        </v-row>
      </div>

      <section v-if="settings.observation && settings.observation.content" class="d-flex justify-center pt-4">
        <div 
          class="text-center"
          style="max-width: 1340px !important"
        >
          <span 
            class="observation-style" 
            :style="
              `
              font-family: ${settings.observation.font || ''} !important; 
              font-size: ${settings.observation['font-size'] || ''} !important; 
              color: ${settings.observation.color} !important; 
              line-height: ${settings.observation['font-size']} !important; 
              font-weight: ${settings.observation.weight} !important;
              font-style: ${settings.observation['font-style']} !important;
              `
            "
          >
            <span v-html="settings.observation.content" />
          </span>
        </div>
      </section>
    </section>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import { GetLayoutSectionMixin } from "../../mixins/GetLayoutSection"
import TitleComponent from "../title/TitleComponent.vue";
import FormTickets from "./formTickets/FormTickets";
import DialogTicket from "./DialogTicket.vue";

// Layouts
import vertical from './layouts/vertical.vue'
import horizontal from './layouts/horizontal.vue'
import formComponent from './layouts/form.vue'
import custom from './layouts/custom.vue'
import newLayout1 from './layouts/newLayout1.vue'
import newLayout2 from './layouts/newLayout2.vue'
import newLayout3 from './layouts/newLayout3.vue'
import newLayout4 from './layouts/newLayout4.vue'
import newLayout5 from './layouts/newLayout5.vue'
import newLayout6 from './layouts/newLayout6.vue'

export default {
  mixins: [GetLayoutSectionMixin],
  components: { 
    TitleComponent, 
    FormTickets, 
    DialogTicket, 
    // Layouts
    vertical, 
    horizontal,
    formComponent,
    custom,
    newLayout1,
    newLayout2,
    newLayout3,
    newLayout4,
    newLayout5,
    newLayout6
  },

  props: {
    settings: { type: Object }
  },

  data() {
    return {
      settingsTitle: null     
    };
  },

  computed: {
    ...mapGetters(["products", "oneCheckoutOpen", 'loadingCheckout', "infos", "tickets", "productErrorMessage"]),

    getComponent () {
      let component = this.settings.layout
      const exclusiveMobileVersion = ['vertical', 'horizontal']

      if (!this.$vuetify.breakpoint.mdAndUp && exclusiveMobileVersion.includes(component)) {
        component = 'horizontal'
      }

      if (component === 'form') component = 'formComponent'

      return component
    },

    splitArray() {
      var res = []
      let mobileOrNo = this.$vuetify.breakpoint.mdAndUp ? this.settings["max-columns"] : 2
      
      let products = this.products ? this.products.products : [];

      if (this.settings.layout === "custom") {
        products = this.settings.items;
        if (!this.$vuetify.breakpoint.mdAndUp) mobileOrNo = 1;
      }

      for (var i = 0; i < products.length; i = i + mobileOrNo) {
        res.push(products.slice(i, i + mobileOrNo));
      }
      return res;
    }
  },

  created() {
    this.updateSettingsTitle()
  },

  watch: {
    settings: {
      deep: true,
      handler () {
        this.updateSettingsTitle()
      }
    }
  },

  methods: {
    updateSettingsTitle () {
      this.settingsTitle = {
        title: this.settings.title,
        subtitle: this.settings.subtitle,
        "background-color": "transparent",
      }
    },

    openCheckout(item) {
      if (!item.encerrado) this.$store.dispatch("setOneCheckoutOpen", true);
    },

    getTicketsForLayoutV2(productsV2) {
      const selectedProducts = productsV2 || []
      const products = this.products.products

      const formatedProducts = products
        .filter(product => {
          const isSelected = selectedProducts.some(p => product.codigo_tipo === p.codigo_tipo && product.codigo_produto === p.codigo)
          return isSelected
        })
        .map(product => {
          const infoOption = selectedProducts.find(p => product.codigo_tipo === p.codigo_tipo && product.codigo_produto === p.codigo) 

          return {
            ...product, 
            valor: product.valor ? product.valor.toLocaleString('pt-BR', {minimumFractionDigits: 2, maximumFractionDigits: 2}) : '0,00',
            ...infoOption
          }
        })
      
      const orderedBySelectedProducts = []
      selectedProducts.forEach((product) => {
        formatedProducts.forEach(formated => {
          if (formated.codigo === product.codigo && formated.codigo_tipo === product.codigo_tipo) orderedBySelectedProducts.push(formated)
        })
      })

      return orderedBySelectedProducts
    },

    onBuyTicket(item) {
      const useCheckoutByProduct = this.settings.checkoutV2ByProduct
      if (!item.encerrado && !this.loadingCheckout) {
        if (useCheckoutByProduct) this.$store.dispatch("setCheckoutByProduct", item.codigo)
        this.$store.dispatch("setLoadingCheckout", true)
        this.$store.dispatch("setOneCheckoutOpen", true)
      }
    }    
  },
};
</script>

<style scoped>
  .v-carousel {
    width: 85vw;
  }

  .div-style-width {
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .v-btn {
    font-size: 14px;
    font-style: normal;
    line-height: 24px;
    letter-spacing: 0.75px;
    text-align: center;
  }

  .observation-style span {
    font-family: inherit !important; 
    font-size: inherit !important; 
    color: inherit !important; 
    line-height: inherit !important; 
    font-weight: inherit !important;
    font-style:  inherit !important;
  }

  .observation-style /deep/ p {
    font-family: inherit !important; 
  }

  .observation-style /deep/ a {
    color: inherit !important; 
    text-decoration: none;
  }
</style>
